/* eslint-disable no-unused-expressions */
import axios from "axios"
import headers from "../../util/headers"

export const getAuditLogs = (baseUrl, params) => {
  const path = `${baseUrl}/backend/audit_logs`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status, headers: resHeaders }) => ({ response: data, status, headers: resHeaders }))
    .catch(error => { error })
}
